import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import type { ReactNode } from 'react';

const SIZE = 32;

function monogram(name: string): string {
  const words = name
    .trim()
    .split(/\s+/)
    .filter((word) => word.length > 0);
  return words
    .slice(0, 2)
    .map((word) => word.charAt(0).toUpperCase())
    .join('');
}

/** The client's mark for the rail: its logo, or a monogram until it has one. */
export function ClientMark({ name, logoUrl }: { name: string; logoUrl: string | null }): ReactNode {
  if (logoUrl !== null) {
    return (
      <Box
        component="img"
        src={logoUrl}
        alt={name}
        sx={{ width: SIZE, height: SIZE, borderRadius: 1, objectFit: 'contain' }}
      />
    );
  }
  return (
    <Box
      role="img"
      aria-label={name}
      sx={{
        width: SIZE,
        height: SIZE,
        borderRadius: 1,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
      }}
    >
      <Typography sx={{ fontSize: 13, fontWeight: 700, lineHeight: 1 }}>
        {monogram(name)}
      </Typography>
    </Box>
  );
}

/** Two-line hover for the client mark: who, and where a click goes. */
export function ClientMarkTooltip({ name }: { name: string }): ReactNode {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
      <Typography sx={{ fontSize: 12, fontWeight: 700 }}>{name}</Typography>
      <Typography sx={{ fontSize: 11, opacity: 0.8 }}>Go to Home</Typography>
    </Box>
  );
}
